import EmbeddedFormPage from './EmbeddedFormPage';

const AnnualTuitionIncreasesPage = () => (
  <EmbeddedFormPage
    titleKey="Annual Tuition Increases"
    description="Fill out this form to plan your Annual Tuition Increase. Annual Tuition Increases help you keep up with rising costs while giving families clear, professional notice of any rate changes."
    formUrl="https://wonderschool.fillout.com/t/1SWKznQGTfus"
  />
);

export default AnnualTuitionIncreasesPage;
